export const steps = ['Connect to engine', 'Select app', 'Develop'];
